import { useEffect } from 'react'
import QueryString from 'query-string'
import { useHistory, useLocation } from 'react-router-dom'
import { REFERRAL_CODE_KEY, PROMO_CODE_KEY } from 'utils/sourceAttributes'

export const useReferralCode = () => {
  const locationState = useLocation()
  const history = useHistory()

  const queryParams = QueryString.parse(locationState.search)
  const { [REFERRAL_CODE_KEY]: referralCode, [PROMO_CODE_KEY]: promoCode } = queryParams

  useEffect(() => {
    if (referralCode && PROMO_CODE_KEY in queryParams) {
      const paramListOmitPromoCode = Object.entries(queryParams).reduce((acc, [key, value]) => {
        if (key === PROMO_CODE_KEY) {
          return acc
        }

        return [...acc, `${key}=${value}`]
      }, [])

      history.replace(`${locationState.pathname}?${paramListOmitPromoCode.join('&')}`)
    }
  }, [referralCode, promoCode, queryParams, history, locationState.pathname])

  return {
    hasReferralCode: !!referralCode,
  }
}
